import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { NumberFormat, filterTextAndNum } from "utils/HelperFunction";
import ThaiBahtText from "thai-baht-text";
import { Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import moment from "moment";
import "moment/locale/th";
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
// Styles
var styles = StyleSheet.create({
    page: {
        fontFamily: "THSarabun",
        fontSize: 12,
        paddingTop: 30,
        paddingBottom: 10,
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: "#fff",
        lineHeight: 1.4
    },
    headerRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12,
        alignItems: "center"
    },
    logo: {
        width: 90
    },
    subTitle: {
        fontSize: 12,
        marginBottom: 2,
        color: "#333"
    },
    title: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#B00412"
    },
    titleBox: {
        textAlign: "right"
    },
    titleCenter: {
        textAlign: "center"
    },
    sectionGroup: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12
    },
    col6: {
        flex: 1
    },
    textEnd: {
        textAlign: "right"
    },
    sectionBox: {
        flex: 1,
        padding: 6,
        marginRight: 8,
        borderBottom: "1px solid #CCC"
    },
    sectionLabel: {
        fontSize: 12,
        color: "#555"
    },
    sectionValue: {
        fontSize: 12,
        fontWeight: "bold",
        marginTop: 2
    },
    docInfoBox: {
        flex: 1,
        padding: 6,
        marginLeft: 8,
        borderRadius: 4,
        backgroundColor: "#FDECEC"
    },
    docInfoRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 4
    },
    docLabel: {
        fontSize: 12,
        color: "#333"
    },
    docValue: {
        fontSize: 12,
        fontWeight: "bold"
    },
    table: {
        display: "table",
        width: "auto",
        marginTop: 2
    },
    tableRow: {
        flexDirection: "row"
    },
    tableHeader: {
        flex: 1,
        borderRight: "1px solid #E2E8F0",
        backgroundColor: "#F6E1E3",
        padding: 6,
        fontSize: 12,
        fontWeight: "bold",
        textAlign: "center"
    },
    tableCell: {
        flex: 1,
        borderRight: "0px solid #E2E8F0",
        borderTop: "0px solid #E2E8F0",
        padding: 5,
        fontSize: 11,
        textAlign: "center"
    },
    footer: {
        marginTop: 24,
        textAlign: "right",
        fontSize: 11
    },
    footerSection: {
        paddingVertical: 4,
        fontSize: 11.5
    },
    footerRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    footerColLeft: {
        flex: 1,
        justifyContent: "flex-start"
    },
    footerColCenter: {
        flex: 1,
        alignItems: "center"
    },
    footerColRight: {
        flex: 1,
        alignItems: "flex-end"
    },
    signSection: {
        paddingTop: 25,
        fontSize: 11.5
    },
    signRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-end"
    },
    signCol: {
        flex: 1,
        alignItems: "center",
        paddingLeft: 4,
        paddingRight: 4
    },
    signLine: {
        color: "#d8d8d8",
        marginBottom: 4
    },
    signDate: {
        borderBottomWidth: 1,
        borderColor: "#d8d8d8",
        paddingHorizontal: 45,
        marginBottom: 4
    },
    signText: {
        marginBottom: 4,
        borderBottom: "1px solid #ebecec",
        width: "100%",
        textAlign: "center",
        color: "#111111"
    }
});
var PDFHeader = function() {
    return /*#__PURE__*/ _jsxs(View, {
        style: styles.headerRow,
        children: [
            /*#__PURE__*/ _jsx(Image, {
                src: "/images/logopardesco.png",
                style: styles.logo
            }),
            /*#__PURE__*/ _jsxs(View, {
                style: {
                    flex: 1,
                    alignItems: "flex-end"
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.subTitle,
                        children: "(ต้นฉบับ)"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.title,
                        children: "ใบเสร็จรับเงิน/ใบกำกับภาษี"
                    })
                ]
            })
        ]
    });
};
var InvoicePdf = function(param) {
    var data = param.data;
    var _data_InvDetail, _data_InvDetail1, _data_InvDetail2, _data_InvDetail3, _data_InvDetail4;
    var _useState = _sliced_to_array(useState(0), 2), sumrowTotalNet = _useState[0], setSumrowTotalNet = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), discounttype = _useState1[0], setDiscounttype = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), discount = _useState2[0], setDiscount = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumDiscount = _useState3[0], setSumDiscount = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumrowVat = _useState4[0], setSumrowVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumrowTax = _useState5[0], setSumrowTax = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), totalnet = _useState6[0], setTotalnet = _useState6[1];
    var _useState7 = _sliced_to_array(useState("-"), 2), paytype = _useState7[0], setPaytype = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), taxstatus = _useState8[0], setTaxstatus = _useState8[1];
    var _useState9 = _sliced_to_array(useState("-"), 2), invCode = _useState9[0], setInvCode = _useState9[1];
    var _useState10 = _sliced_to_array(useState("-"), 2), billCode = _useState10[0], setBillCode = _useState10[1];
    var _useState11 = _sliced_to_array(useState(false), 2), taxSwitch = _useState11[0], setTaxSwitch = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: ""
    }), 2), partnerInfo = _useState12[0], setPartnerInfo = _useState12[1];
    useEffect(function() {
        if (data) {
            setPartnerInfo({
                companyName: data.inv_invoice_businesstype == 2 ? filterTextAndNum(data.inv_invoice_comprefixname ? data.inv_invoice_comprefixname : "") + " " + filterTextAndNum(data.inv_invoice_name ? data.inv_invoice_name : "") + " " + filterTextAndNum(data.inv_invoice_suffixname ? data.inv_invoice_suffixname : "") : filterTextAndNum(data.inv_invoice_prefixid == 1 && "นาย" || data.inv_invoice_prefixid == 2 && "นาง" || data.inv_invoice_prefixid == 3 && "นางสาว" || data.inv_invoice_prefixid == 4 && "ไม่ระบุ" || data.inv_invoice_prefixid == "" && "") + " " + filterTextAndNum(data.inv_invoice_fname) + " " + filterTextAndNum(data.inv_invoice_lname),
                companyBranch: data.inv_invoice_branchname ? data.inv_invoice_branchname : "",
                companyTaxId: data.inv_invoice_taxid ? data.inv_invoice_taxid : "",
                companyAddress: data.inv_invoice_address,
                companyProvince: data.Invprovinceid ? JSON.parse(data.Invprovinceid.province_name).th : "",
                companyDistrict: data.Invsubprovinceid ? JSON.parse(data.Invsubprovinceid.district_name).th : "",
                companySubDistrict: data.Invdistrictid ? JSON.parse(data.Invdistrictid.subdistrict_name).th : "",
                companyZipCode: data.inv_invoice_zipcodeid ? data.inv_invoice_zipcodeid : "",
                contractName: data.inv_invoice_mainfname && data.inv_invoice_mainlname ? data.inv_invoice_mainfname + " " + data.inv_invoice_mainlname : data.inv_invoice_mainfname ? data.inv_invoice_mainfname : data.inv_invoice_mainlname ? data.inv_invoice_mainlname : "",
                contactPhone: data.inv_invoice_mainphone ? data.inv_invoice_mainphone : "",
                contactEmail: data.inv_invoice_mainemail ? data.inv_invoice_mainemail : ""
            });
            setDiscounttype(data.inv_invoice_discounttype ? data.inv_invoice_discounttype : 1);
            setDiscount(data.inv_invoice_discount ? data.inv_invoice_discount : 0);
            setTotalnet(data.inv_invoice_totalnet ? data.inv_invoice_totalnet : 0);
            setSumDiscount(data.inv_invoice_discountreal ? data.inv_invoice_discountreal : 0);
            setSumrowTotalNet(data.inv_invoice_totalprice ? data.inv_invoice_totalprice : 0);
            setSumrowTax(data.inv_invoice_totaltax ? data.inv_invoice_totaltax : 0);
            setSumrowVat(data.inv_invoice_totalvat ? data.inv_invoice_totalvat : 0);
            setTaxSwitch(data.inv_invoice_taxstatus == 1 ? true : false);
            setPaytype(data.inv_invoice_paytype == 1 && "เงินสด" || data.inv_invoice_paytype == 2 && "โอนธนาคาร" || data.inv_invoice_paytype == 3 && "เช็คเงินสด" || "-");
            setTaxstatus(data.inv_invoice_taxstatus ? data.inv_invoice_taxstatus : 0);
            setInvCode(data.inv_invoice_code ? data.inv_invoice_code : "-");
            setBillCode(data.BlBilling && data.BlBilling.bl_billing_code ? data.BlBilling.bl_billing_code : "-");
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsx(PDFHeader, {}),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ขาย :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "0105568029236"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "วริธร สวยงาม"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "0949280297"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: 6,
                                width: 150
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "เลขที่เอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: invCode !== null && invCode !== void 0 ? invCode : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ออกเอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ครบกำหนด :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.inv_invoice_expiredate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "อ้างอิง :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: billCode !== null && billCode !== void 0 ? billCode : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 240,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลูกค้า :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyName,
                                                " ",
                                                partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                " ",
                                                partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.contractName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactPhone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactEmail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.table,
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: [
                                "รายการ",
                                "จำนวน",
                                "ราคาต่อหน่วย",
                                "ส่วนลด",
                                "ราคารวม"
                            ].map(function(h, i) {
                                return /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: h
                                }, i);
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.InvDetail) && (data === null || data === void 0 ? void 0 : (_data_InvDetail = data.InvDetail) === null || _data_InvDetail === void 0 ? void 0 : _data_InvDetail.length) > 0 ? data === null || data === void 0 ? void 0 : (_data_InvDetail1 = data.InvDetail) === null || _data_InvDetail1 === void 0 ? void 0 : _data_InvDetail1.map(function(ele, i) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: [
                                            styles.tableCell,
                                            {
                                                alignItems: "flex-start"
                                            }
                                        ],
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: "".concat(i + 1, ". ").concat(ele.inv_detail_name)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: ele.inv_detail_remark ? "(" + ele.inv_detail_remark + ")" : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.inv_detail_amount
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.inv_detail_price, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.inv_detail_discounttype == 1 ? NumberFormat(ele.inv_detail_discount, 2) : ele.inv_detail_discount + "%"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.inv_detail_net, 2)
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: [
                                    styles.tableCell,
                                    {
                                        flex: 1
                                    }
                                ],
                                children: "ไม่พบข้อมูล"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: ((_data_InvDetail2 = data.InvDetail) === null || _data_InvDetail2 === void 0 ? void 0 : _data_InvDetail2.length) > 5 && 100 || ((_data_InvDetail3 = data.InvDetail) === null || _data_InvDetail3 === void 0 ? void 0 : _data_InvDetail3.length) < 5 && 150 || ((_data_InvDetail4 = data.InvDetail) === null || _data_InvDetail4 === void 0 ? void 0 : _data_InvDetail4.length) > 10 && 10,
                        borderBottom: "1px solid #ebecec",
                        borderTop: "1px solid #ebecec",
                        padding: "10px 2px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 40,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4,
                                        fontWeight: "bold"
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 30
                                        },
                                        children: "สรุป"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าก่อนส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "ส่วนลด",
                                                " ",
                                                discounttype == 1 ? NumberFormat(discount, 2) : discount,
                                                " ",
                                                discounttype == 1 ? "บาท" : "เปอร์เซ็น"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าหลังหักส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "ภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "หัก ณ ที่จ่าย ",
                                                taxstatus == 1 ? data.inv_invoice_tax : 0,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(taxstatus == 1 ? sumrowTax : 0, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: [
                                styles.docValue,
                                {
                                    width: 200,
                                    paddingRight: 10,
                                    fontSize: 13
                                }
                            ],
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    backgroundColor: "#F6E1E3",
                                    borderRadius: 5,
                                    padding: 6
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            flexDirection: "row",
                                            marginBottom: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: 100
                                                },
                                                children: "มูลค่าสุทธิรวม"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: [
                                                    styles.textEnd,
                                                    {
                                                        width: 50,
                                                        marginRight: 3,
                                                        color: "#b00412",
                                                        fontWeight: 700
                                                    }
                                                ],
                                                children: NumberFormat(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    flex: 1
                                                },
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: [
                                            styles.titleCenter,
                                            {
                                                flexDirection: "row",
                                                marginBottom: 4
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 200
                                            },
                                            children: [
                                                "(",
                                                " ",
                                                ThaiBahtText(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2),
                                                " ",
                                                ")"
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        borderBottom: "1px solid #ebecec",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "ชำระเงิน"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 80
                                        },
                                        children: "วันที่ชำระ :"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            flex: 1
                                        },
                                        children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 80
                                        },
                                        children: "ช่องทางการชำระ :"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 30
                                        },
                                        children: paytype
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: [
                                            styles.textEnd,
                                            {
                                                width: 80,
                                                marginRight: 3
                                            }
                                        ],
                                        children: NumberFormat(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            flex: 1
                                        },
                                        children: "บาท"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: 40,
                            paddingRight: 10
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "หมายเหตุ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 250,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        children: data.inv_invoice_ramark ? data.inv_invoice_ramark : ""
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.footerSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.footerRow,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColLeft,
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    children: [
                                        "ในนาม ",
                                        (partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.companyName) || "-"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColCenter,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColRight,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.signSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.signRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        width: "25%"
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signText
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้จ่าย"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        width: "20%"
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signText
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        width: "10%"
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        width: "25%"
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signText
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้รับเงิน"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        width: "20%"
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signText,
                                        children: data.inv_invoice_issuedate ? moment(data.inv_invoice_issuedate).format("DD/MM/YYYY") : ""
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default InvoicePdf;
